export { MainBlockStyle } from "./MainBlockStyle";
export { MainBlock } from "./MainBlock";
